
import { SortUsersE } from "@components/Pages/Clients/Clients.utils";
import { MinerSortFields } from "@components/Pages/Machines/MinersTable/useMinersTableControl";

export const getSorting = (SORTING_KEY: string) =>
  localStorage.getItem(SORTING_KEY) === null
    ? undefined
    : +(localStorage.getItem(SORTING_KEY) as string);

export const saveSorting = (SORTING_KEY: string, sort?: MinerSortFields | SortUsersE) => {
  localStorage.setItem(SORTING_KEY, sort as unknown as string);
};

export const deleteSorting = (SORTING_KEY: string) => {
  localStorage.removeItem(SORTING_KEY);
};
